/**
 * @generated SignedSource<<4a4f73dfae8c08f67bcc197df14a66a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CancelStage = "CancelImpossible" | "CancelPossibleAfterDeclare" | "CancelPossibleBeforeDeclare" | "CancelPossibleImmediately" | "Canceling";
export type RefundStage = "Declare" | "PaymentComplete" | "RefundCompleteA" | "RefundCompleteB" | "RefundDetermine" | "RefundPreDetermine" | "Review" | "Unknown";
export type RefundStatus = "ApplyComplete" | "ApplyImpossible" | "ApplyPossible" | "Complete" | "Impossible" | "None" | "Possible" | "RefundFinish" | "RefundImpossible" | "Retry";
export type RefundSubStage = "DeclareSpecialFeeA" | "DeclareSpecialFeeB" | "Default" | "ReviewCs" | "ReviewWritingComplete";
import { FragmentRefs } from "relay-runtime";
export type IndisSection$data = {
  readonly bznavRefund: {
    readonly user: {
      readonly indis: ReadonlyArray<{
        readonly applicationDt: string | null | undefined;
        readonly businessInfo: {
          readonly taxpayerName: string | null | undefined;
        } | null | undefined;
        readonly cancelStage: CancelStage | null | undefined;
        readonly cenSnmcTxreAmt: number | null | undefined;
        readonly empIncrEtrpTxamtDdcAmt: number | null | undefined;
        readonly intgEmpTxamtDdcAmt: number | null | undefined;
        readonly lostReason: string | null | undefined;
        readonly office: string | null | undefined;
        readonly paymentAmount: number | null | undefined;
        readonly paymentClosingDt: string | null | undefined;
        readonly paymentExpectDt: string | null | undefined;
        readonly reSearchRequestId: number | null | undefined;
        readonly refundAmount: string;
        readonly refundHistoryId: string;
        readonly refundId: string;
        readonly refundReportDt: string | null | undefined;
        readonly refundResultDt: string | null | undefined;
        readonly refundResultExpectDt: string | null | undefined;
        readonly refundStage: RefundStage | null | undefined;
        readonly refundStatus: RefundStatus;
        readonly refundSubStage: RefundSubStage | null | undefined;
        readonly sctyInfeeTxamtDdcAmt: number | null | undefined;
        readonly snmcSpcTxreAmt: number | null | undefined;
        readonly tin: string;
        readonly userFee: number | null | undefined;
        readonly virtualAccountInfo: {
          readonly account: string;
          readonly bank: string;
          readonly owner: string;
          readonly paymentAmount: string;
        } | null | undefined;
      }> | null | undefined;
      readonly previousIndis: ReadonlyArray<{
        readonly __typename: "RefundHistoryType";
      }> | null | undefined;
      readonly tritxIndis: ReadonlyArray<{
        readonly applicationDt: string | null | undefined;
        readonly businessInfo: {
          readonly taxpayerName: string | null | undefined;
        } | null | undefined;
        readonly cancelStage: CancelStage | null | undefined;
        readonly refundAmount: string;
        readonly refundId: string;
        readonly refundStage: RefundStage | null | undefined;
        readonly refundStatus: RefundStatus;
        readonly tritxReSearchRequestId: number | null | undefined;
      }> | null | undefined;
    };
  };
  readonly " $fragmentType": "IndisSection";
};
export type IndisSection$key = {
  readonly " $data"?: IndisSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"IndisSection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundStatus",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundStage",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundAmount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentAmount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "applicationDt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelStage",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "BusinessInfo",
  "kind": "LinkedField",
  "name": "businessInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxpayerName",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IndisSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BznavRefundOutput",
      "kind": "LinkedField",
      "name": "bznavRefund",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RefundUserType",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RefundHistoryType",
              "kind": "LinkedField",
              "name": "indis",
              "plural": true,
              "selections": [
                {
                  "alias": "refundHistoryId",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refundSubStage",
                  "storageKey": null
                },
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refundReportDt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refundResultDt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refundResultExpectDt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "paymentClosingDt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "paymentExpectDt",
                  "storageKey": null
                },
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userFee",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lostReason",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tin",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "office",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "snmcSpcTxreAmt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cenSnmcTxreAmt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "empIncrEtrpTxamtDdcAmt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "intgEmpTxamtDdcAmt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sctyInfeeTxamtDdcAmt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "reSearchRequestId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VirtualAccountType",
                  "kind": "LinkedField",
                  "name": "virtualAccountInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "owner",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bank",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "account",
                      "storageKey": null
                    },
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                },
                (v7/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RefundHistoryType",
              "kind": "LinkedField",
              "name": "previousIndis",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RefundHistoryType",
              "kind": "LinkedField",
              "name": "tritxIndis",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/),
                (v5/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tritxReSearchRequestId",
                  "storageKey": null
                },
                (v7/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "702badbbf4f10f28994c74dae1cc3b75";

export default node;
